/*
Created Success Reducer to save questionnaire evaluation data
 */
export function questionnaireEvaluationOverrideScoreSuccessReducer(state, action) {
    return Object.assign(Object.assign({}, state), { isScoreOverrideSuccess: true });
}
//# sourceMappingURL=questionnaireEvaluationOverrideScoreSuccessReducer.js.map